import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
import { getAuthStorage } from "../../../api/service-localstorage";
import { mapState } from 'vuex';
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    userType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isTrialUser: true
    };
  },
  mounted: function mounted() {
    var _getAuthStorage = getAuthStorage(),
        sysVersionInfo = _getAuthStorage.sysVersionInfo;

    this.isTrialUser = sysVersionInfo === 0;
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    timeliness: function timeliness(state) {
      return state.timeliness;
    }
  })), {}, {
    isDisabled: function isDisabled() {
      if (this.isTrialUser || !this.timeliness) {
        return false;
      } else {
        if (this.userType === 'speciality' && this.type === 'standard') {
          return true;
        } else if (this.userType === 'enjoy' && (this.type === 'standard' || this.type === 'speciality')) {
          return true;
        } else {
          return false;
        }
      }
    },
    btnTxt: function btnTxt() {
      if (this.type === 'customized') {
        return '联系商务经理';
      } else {
        if (this.isTrialUser) {
          return '点击购买';
        } else {
          if (this.userType === this.type) {
            return '点击续费';
          } else {
            return '点击购买';
          }
        }
      }
    }
  })
};